export default {
  首页: "Página inicial",
  资产: "Ativos",
  币币: "Spot",
  快捷买币: "Comprar cripto rapidamente",
  "支持多种方式购买，购买更简单":
    "Compre facilmente com vários métodos de pagamento",
  语言设置: "Definições de idioma",
  确认恢复: "Confirmar recuperação",
  "输入邮箱，方便我们联系您":
    "Introduza o seu e-mail para que possamos contactá-lo",
  划转: "Transferir",
  行情: "Mercado",
  "24H成交": "Volume 24h",
  累计收益: "Rendimento total",
  充值时间: "Data de depósito",
  到期时间: "Data de expiração",
  数量: "Quantidade",
  操作: "Ação",
  资产信息: "Informações dos ativos",
  复制地址: "Copiar endereço",
  链名称: "Nome da blockchain",
  充值地址: "Endereço de depósito",
  收款地址: "Endereço de recebimento",
  账单: "Fatura",
  提现金额: "Montante a levantar",
  接收地址: "Endereço de recebimento",
  交易密码: "Palavra-passe de negociação",
  提现全部: "Levantar tudo",
  保存图片: "Guardar imagem",
  输入您的交易密码: "Insira a sua palavra-passe de negociação",
  确定: "Confirmar",
  地址: "Endereço",
  注册时间: "Data de registo",
  取消: "Cancelar",
  是否划转: "Transferir?",
  登录: "Iniciar sessão",
  我的地址: "Os meus endereços",
  登录密码和交易密码: "Palavra-passe de início de sessão e de negociação",
  注册: "Registar",
  密码: "Palavra-passe",
  设置密码: "Definir palavra-passe",
  重复密码: "Repetir palavra-passe",
  新密码: "Nova palavra-passe",
  确认新密码: "Confirmar nova palavra-passe",
  充值: "Depositar",
  充值货币: "Depositar moeda",
  合约账户充值: "Depositar na conta de futuros",
  账户充值: "Depositar na conta",
  其他: "Outro",
  我的邀请码: "O meu código de convite",
  提现: "Levantar",
  客服: "Apoio ao cliente",
  持有详情: "Detalhes da posse",
  请输入内容: "Insira o conteúdo",
  邀请好友来领取奖励: "Convide amigos e receba recompensas",
  复制链接: "Copiar link",
  重复设置新的密码: "Repetir nova palavra-passe",
  保存: "Guardar",
  我的: "Minha conta",
  "邮箱/手机号": "E-mail/Telefone",
  备注: "Observação",
  地址管理: "Gestão de endereços",
  我的团队: "A minha equipa",
  联系我们: "Contacte-nos",
  竭诚为您服务: "Estamos ao seu dispor",
  提取收益: "Retirar rendimento",
  带给我的收益: "Rendimento gerado",
  添加: "Adicionar",
  名称: "Nome",
  添加地址: "Adicionar endereço",
  修改地址: "Modificar endereço",
  可提现: "Levantável",
  安全中心: "Centro de segurança",
  收益划转: "Transferir rendimento",
  通知中心: "Notificações",
  "累计收益:": "Rendimento total:",
  注册用户: "Utilizadores registados",
  奖励规则: "Regras de recompensa",
  帮助反馈: "Ajuda e feedback",
  邀请好友: "Convidar amigos",
  恢复身份: "Recuperar identidade",
  选择语言: "Selecionar idioma",
  设置新的密码: "Definir nova palavra-passe",
  暂无活动: "Nenhuma atividade ativa",
  "月增长量(+)": "Crescimento mensal (+)",
  可提取: "Levantável",
  反馈类型: "Tipo de feedback",
  赠送: "Oferta",
  已经复制: "Copiado",
  保存成功: "Guardado com sucesso",
  划转成功: "Transferência efetuada com sucesso",
  过期: "Expirado",
  提交成功: "Submetido com sucesso",
  "服务器繁忙，稍后在试": "Servidor ocupado, tente novamente mais tarde",
  全部: "Todos",
  一级: "Nível 1",
  二级: "Nível 2",
  三级: "Nível 3",
  级: "Nível",
  删除成功: "Eliminado com sucesso",
  选择地址: "Selecionar endereço",
  不再提醒: "Não voltar a mostrar",
  "最小充值金额：": "Montante mínimo de depósito:",
  选择币种: "Selecionar criptomoeda",
  输入投资金额: "Insira o montante de investimento",
  输入账户密码: "Insira a palavra-passe da conta",
  投资: "Investir",
  订单编号: "Número da encomenda",
  投资周期: "Período de investimento",
  投资资金: "Montante investido",
  投资时间: "Data do investimento",
  状态: "Estado",
  投资中: "Ativo",
  已到期: "Expirado",
  暂无数据: "Sem dados",
  转入: "Transferir para",
  邮箱: "E-mail",
  请输入邮箱: "Insira o e-mail",
  请输入格式正确的邮箱: "Insira um e-mail válido",
  请输入验证码: "Insira o código de verificação",
  获取验证码: "Obter código de verificação",
  请输入邀请码: "Insira o código de convite",
  今天: "Hoje",
  昨天: "Ontem",
  最近七天: "Últimos 7 dias",
  邀请: "Convidar",
  购买数量: "Quantidade a comprar",
  产品详情: "Detalhes do produto",
  币种: "Criptomoeda",
  利息币种: "Moeda de rendimento",
  理财类型: "Tipo de produto financeiro",
  产品费率: "Taxas do produto",
  进行中: "Ativo",
  每天: "Diariamente",
  请输入搜索关键词: "Insira o termo de pesquisa",
  通知: "Notificações",
  查看更多: "Ver mais",
  理财宝: "Produtos financeiros",
  周期: "Prazo",
  年利率: "Taxa de juro anual (APY)",
  更多产品: "Mais produtos",
  灵活存取: "Poupança flexível",
  稳定收益: "Rendimento estável",
  合约指南: "Guia de futuros",
  资金划转出: "Transferência enviada",
  矿池收益: "Recompensa de mineração",
  提现手续费: "Taxa de levantamento",
  冻结资金: "Ativos congelados",
  解冻资金: "Libertar ativos congelados",
  闪兑支出: "Despesa de conversão rápida",
  闪兑收入: "Receita de conversão rápida",
  闪兑手续费: "Taxa de conversão rápida",
  合约支出: "Despesa de futuros",
  合约收入: "Receita de futuros",
  输入的金额不可大于可用金额:
    "O montante não pode ser superior ao montante disponível",
  全部兑换成功: "Conversão total efetuada com sucesso",
  返回: "Voltar",
  查看历史: "Ver histórico",
  闪兑历史: "Histórico de conversão rápida",
  支付: "Pagar",
  获取: "Obter",
  时间: "Tempo",
  手续费: "Taxa de transação",
  折扣: "Desconto",
  价格: "Preço",
  逐仓: "Margem isolada",
  全仓: "Margem cruzada",
  市价委托: "Ordem de mercado",
  限价委托: "Ordem limitada",
  请输入本金: "Insira o montante principal",
  请输入价格: "Insira o preço",
  "可做空/做多": "Possível vender a descoberto/comprar",
  设置止盈止损: "Definir take-profit / stop-loss",
  止盈价: "Preço de take-profit",
  止损价: "Preço de stop-loss",
  成本: "Preço de custo",
  做多: "Comprar (Long)",
  做空: "Vender a descoberto (Short)",
  仓位信息: "Informações da posição",
  一键平仓: "Fechar posição (um clique)",
  永续: "Perpétuo",
  浮动盈亏: "Lucro/Perda não realizado",
  平仓: "Fechar posição",
  反向开仓: "Abrir posição inversa",
  一键撤销: "Cancelar tudo (um clique)",
  倍杠杆: "x alavancagem",
  执行价格: "Preço de execução",
  委托数量: "Quantidade da ordem",
  保证金: "Margem",
  成交价: "Preço de execução",
  创建时间: "Data de criação",
  撤销: "Cancelar",
  合约市场: "Mercado de futuros",
  交易方向: "Direção da negociação",
  委托价格: "Preço da ordem",
  委托金额: "Montante da ordem",
  资金费率: "Taxa de financiamento",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Taxa periódica paga por posições compradas e vendidas, liquidada a cada 8 horas.",
  "资金费率为正，多方向空方支付资金费用。":
    "Com uma taxa de financiamento positiva, as posições compradas pagam às posições vendidas.",
  "资金费率为负，空方向多方支付资金费用。":
    "Com uma taxa de financiamento negativa, as posições vendidas pagam às posições compradas.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Tem a certeza de que deseja abrir uma posição inversa? Isto comprará a direção oposta da sua posição atual.",
  "仓位止盈/止损": "Take-profit / Stop-loss para posição",
  合约名称: "Contrato de futuros",
  开仓价格: "Preço de abertura",
  指数价格: "Preço do índice",
  止盈设置: "Definições de take-profit",
  请输入止盈价: "Insira o preço de take-profit",
  "当指数价格触达*时，将会触发委托平仓":
    "Quando o preço do índice atingir *, será acionada uma ordem de fecho.",
  预计盈亏: "Lucro/Perda esperado",
  当前仓位: "Posição atual",
  平仓金额: "Montante de fecho",
  仓位模式: "Modo de posição",
  全仓模式: "Modo de margem cruzada",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "No modo de margem cruzada, todos os ativos disponíveis na sua conta de futuros são usados como margem. A liquidação ocorre quando a perda excede o seu saldo total, resultando na perda de toda a sua margem e posição.",
  逐仓模式: "Modo de margem isolada",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Um montante específico de margem é atribuído a uma posição. Se a perda de margem cair abaixo do nível de margem de manutenção, a posição é liquidada. Pode aumentar ou diminuir a margem para esta posição.",
  "是否撤销？": "Cancelar ordem?",
  "是否一键撤销？": "Cancelar todas as ordens?",
  "是否一键平仓？": "Fechar todas as posições?",
  持仓保证金: "Margem da posição atual",
  风险率: "Taxa de risco",
  未实现盈亏: "Lucro/Perda não realizado",
  可用保证金: "Margem disponível",
  净值: "Valor líquido",
  账户余额: "Saldo da conta",
  合约计算器: "Calculadora de futuros",
  交易记录: "Histórico de transações",
  "*倍杠杆": "*x alavancagem",
  "平仓盈亏：": "Lucro/Perda realizado:",
  时间筛选: "Filtro de tempo",
  仓位类型: "Tipo de posição",
  订单状态: "Estado da ordem",
  订单类型: "Tipo de ordem",
  平仓价格: "Preço de fecho",
  持仓数量: "Quantidade da posição",
  "手续费(%)": "Taxa de transação (%)",
  平仓时间: "Data de fecho",
  平仓类型: "Tipo de fecho",
  手动平仓: "Fecho manual",
  强制平仓: "Liquidação forçada",
  近1天: "Último dia",
  近7天: "Últimos 7 dias",
  近30天: "Últimos 30 dias",
  近180天: "Últimos 180 dias",
  持仓: "Posição aberta",
  已取消: "Cancelado",
  分时: "Intradiário",
  "24H额(USDT)": "Volume 24h (USDT)",
  "24H低": "Mínimo 24h",
  "24H量(BTC)": "Volume 24h (BTC)",
  "24H高": "Máximo 24h",
  "10秒": "10 segundos",
  "30秒": "30 segundos",
  "1分": "1 minuto",
  "3分": "3 minutos",
  "5分": "5 minutos",
  "30分": "30 minutos",
  "1小时": "1 hora",
  "4小时": "4 horas",
  "8小时": "8 horas",
  "1天": "1 dia",
  "1周": "1 semana",
  "1月": "1 mês",
  单向持仓: "Posição unidirecional",
  杠杆: "Alavancagem",
  仓位: "Posição",
  计算结果: "Resultado",
  盈亏: "Lucro/Perda",
  收益率: "Rendimento",
  计算结果仅供参考: "O resultado é indicativo",
  成交后仓位大小: "Tamanho da posição após execução",
  "计算结果仅供参考,实际结果可能因费率差异":
    "O resultado é indicativo, os resultados reais podem variar devido a taxas.",
  目标价格: "Preço alvo",
  开始计算: "Calcular",
  强平价格: "Preço de liquidação",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Verifique cuidadosamente o nome da blockchain antes de depositar. Depósitos incorretos não podem ser revertidos. O montante mínimo de depósito é *. Depósitos abaixo deste valor não serão processados. Não envie outros ativos para este endereço. Não utilize endereços ICO ou de crowdfunding para levantamentos.",
  "最小输入*": "Mínimo {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "A quantidade mínima de levantamento é *. As taxas de levantamento serão deduzidas do montante levantado. Verifique cuidadosamente o endereço do destinatário. Não envie * para endereços fora de *. Não utilize endereços ICO ou de crowdfunding.",
  退出登录: "Terminar sessão",
  加仓: "Aumentar posição",
  新增仓位: "Nova posição",
  输入加仓金额: "Insira o montante para aumentar a posição",
  "当前可用:": "Atualmente disponível:",
  资产账单: "Fatura de ativos",
  保存二维码: "Guardar código QR",
  温馨提示: "Aviso",
  "请注意：您当前使用的网络": "Atenção: Está a utilizar a rede",
  输入提现地址: "Insira o endereço de levantamento",
  "可用金额：": "Montante disponível:",
  输入资产密码: "Insira a palavra-passe de ativos",
  可用手续费: "Taxa disponível",
  "折扣%": "Desconto %",
  实扣手续费: "Taxa efetivamente cobrada",
  实际到账: "Montante efetivamente recebido",
  未设置资产密码: "Palavra-passe de ativos não definida",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Para sua segurança, defina uma palavra-passe de ativos antes de efetuar levantamentos.",
  热榜: "Populares",
  涨幅榜: "Maiores altas",
  跌幅榜: "Maiores quedas",
  成交额榜: "Ranking de volume",
  关于我们: "Sobre nós",
  登录密码: "Palavra-passe de início de sessão",
  设置: "Definições",
  资产密码: "Palavra-passe de ativos",
  修改登录密码: "Alterar palavra-passe de início de sessão",
  原密码: "Palavra-passe antiga",
  请输入新密码: "Insira a nova palavra-passe",
  请输入原密码: "Insira a palavra-passe antiga",
  确认密码: "Confirmar palavra-passe",
  确定修改: "Confirmar alteração",
  修改资产密码: "Alterar palavra-passe de ativos",
  验证码: "Código de verificação",
  资产密码使用提示: "Dicas para palavra-passe de ativos",
  "资产密码用于转移、提取资产和交易。":
    "A palavra-passe de ativos é usada para transferir, levantar e negociar ativos.",
  "创建与登录密码不同的资产密码。":
    "Crie uma palavra-passe de ativos diferente da palavra-passe de início de sessão.",
  "定期更改您的资产密码。":
    "Altere a sua palavra-passe de ativos regularmente.",
  提币历史: "Histórico de levantamentos",
  "金额/余额": "Montante/Saldo",
  "手续费/折扣": "Taxa/Desconto",
  自选: "Favoritos",
  现货: "Spot",
  市价: "Preço de mercado",
  止损设置: "Definições de stop-loss",
  合约K线图: "Gráfico de futuros",
  "24H量": "Volume 24h",
  "24H额": "Volume 24h (USDT)",
  合作指南: "Guia de parceiro",
  盈亏计算: "Cálculo de lucro/perda",
  当前可用: "Atualmente disponível",
  请输入加仓金额: "Insira o montante para aumentar a posição",
  请重新输入加仓金额: "Insira novamente o montante para aumentar a posição",
  平仓数量: "Quantidade a fechar",
  欢迎登录: "Bem-vindo de volta",
  "忘记密码?": "Esqueceu a palavra-passe?",
  "还没有账号？": "Ainda não tem conta?",
  立即注册: "Registar agora",
  繁體中文: "Chinês tradicional",
  找回密码: "Recuperar palavra-passe",
  下一步: "Seguinte",
  注册账户: "Registar conta",
  "请输入邀请码(选填)": "Insira o código de convite (opcional)",
  谢邀豪礼: "Bónus de convite",
  "24小时邀请好友排名": "Ranking de convites 24h",
  "*人": "* pessoas",
  "差*人": "Faltam * pessoas",
  "已超过10万人，每月轻松赚钱":
    "Mais de 100.000 utilizadores, ganhe dinheiro facilmente todos os meses",
  最高: "Máximo",
  邀请链接: "Link de convite",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Partilhe as taxas de transação geradas pelos seus amigos (spot, futuros, margem, conversão rápida).",
  平台和您一起分享手续费: "Partilhe as taxas de transação com a plataforma",
  "*级": "* nível",
  规则: "Regras",
  我的好友: "Os meus amigos",
  好友详情: "Detalhes do amigo",
  获得好友佣金方案: "Plano de comissão de amigo",
  我的等级: "O meu nível",
  我的邀请数据: "As minhas estatísticas de convite",
  当前等级: "Nível atual",
  平台奖励您: "Recompensa da plataforma para si",
  最高可获取平台奖励: "Recompensa máxima da plataforma",
  邀请规则: "Regras de convite",
  "邀请*级有效好友": "Convide amigos ativos de nível *",
  好友等级: "Nível do amigo",
  人: "pessoas",
  奖金派送: "Pagamento de bónus",
  平台奖励: "Recompensa da plataforma",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "A plataforma reserva-se o direito de interpretação final. Em caso de atividades fraudulentas, as recompensas serão deduzidas e a sua conta será congelada. Os ativos perdidos não podem ser recuperados.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "A sua conta deve ser ativa, definida como um depósito de pelo menos * USDT em qualquer criptomoeda.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "O seu amigo convidado deve ser um subordinado ativo, definido como um depósito de pelo menos * USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "O convidador e o convidado não podem partilhar o mesmo endereço IP.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "O nível VIP é determinado pelo número de amigos convidados de nível *.",
  佣金成分: "Componentes da comissão",
  收益统计: "Estatísticas de rendimento",
  昨日收益: "Rendimento de ontem",
  月收益: "Rendimento mensal",
  获取收益: "Obter rendimento",
  "总收益：": "Rendimento total:",
  "*级好友": "Amigos de nível *",
  理财购买: "Comprar produto financeiro",
  期限: "Prazo",
  可用金额: "Montante disponível",
  预估收益: "Rendimento estimado",
  申购上限: "Compra máxima",
  项目剩余: "Restante do projeto",
  "买入后预计*(SGT)开始计算收益。":
    "O rendimento começará a ser calculado aproximadamente às *(SGT) após a compra.",
  计息日: "Início da contagem de juros",
  申购日: "Data da compra",
  到账日: "Data de crédito",
  到期自动续投: "Reinvestimento automático no vencimento",
  申购: "Comprar",
  搜索理财项目: "Pesquisar produto financeiro",
  超高年化随心选: "Escolha entre produtos com alto rendimento",
  "自由选择理财币种，稳定超额收益":
    "Escolha livremente a sua criptomoeda para rendimentos estáveis e acima da média",
  理财总资产: "Ativos totais investidos",
  申购数量: "Quantidade a comprar",
  立即购买: "Comprar agora",
  年化收益率: "Rendimento percentual anual (APY)",
  理财订单: "Encomendas de produtos financeiros",
  持有: "Em posse",
  申购份额: "Parte comprada",
  到账日期: "Data de crédito",
  申购成功: "Compra efetuada com sucesso",
  到期: "Expirado",
  是否选择做多: "Comprar (Long)?",
  "可用余额为0 不能操作": "O saldo é 0, ação não possível",
  福利中心: "Centro de bónus",
  奖励记录: "Histórico de recompensas",
  我获取到的奖励: "As minhas recompensas obtidas",
  总价值: "Valor total",
  新手任务: "Tarefas para novos utilizadores",
  身份认证: "Verificação de identidade (KYC)",
  身份验证: "Verificação de identidade",
  去验证: "Verificar agora",
  审核中: "Em espera",
  已验证: "Verificado",
  认证失败: "Verificação falhou",
  基础认证: "Verificação básica",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Atenção: As informações verificadas não podem ser alteradas. Introduza dados corretos.",
  "国家/地区": "País/Região",
  请选择: "Selecionar",
  证件类型: "Tipo de documento",
  证件编码: "Número do documento",
  身份证: "Cartão de cidadão",
  护照: "Passaporte",
  驾驶证: "Carta de condução",
  请输入编码: "Insira o número",
  名字: "Nome próprio",
  请输入: "Insira",
  中间名: "Nome do meio",
  选填: "Opcional",
  姓氏: "Apelido",
  中国: "China",
  身份上传: "Carregar documento de identificação",
  上传身份证: "Carregar cartão de cidadão",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Carregue em formato JPG/JPEG/PNG. Certifique-se de que as imagens são nítidas, completas e com iluminação uniforme. Máximo *MB.",
  确定提交: "Submeter",
  去认证: "Verificar",
  挑战任务: "Tarefas de desafio",
  注册认证任务: "Tarefa de registo e verificação",
  完成注册认证即可领取: "Conclua o registo e a verificação para receber",
  领取奖励: "Receber recompensa",
  新人豪礼: "Bónus de boas-vindas",
  "参与人数：": "Número de participantes:",
  条件: "Condição",
  入金量: "Montante depositado",
  完成: "Concluído",
  任务奖励: "Recompensa da tarefa",
  距任务更新: "Até à atualização da tarefa",
  "条件：": "Condição:",
  活动规则: "Regras da atividade",
  奖励明细: "Detalhes da recompensa",
  已获得: "Obtido",
  交易奖励: "Recompensa de negociação",
  Win奖励: "Recompensa WIN",
  已领取: "Recebido",
  亏损金额超过: "Montante de perda excede",
  单笔开仓金额超过: "Montante de ordem única excede",
  交易量: "Volume de negociação",
  待完成: "Por concluir",
  入金: "Depositar",
  盈利金额超过: "Montante de lucro excede",
  开仓金额: "Montante da ordem",
  开仓金: "Montante da ordem",
  盈利: "Lucro",
  亏损: "Perda",
  领取: "Receber",
  未领取: "Não recebido",
  待领取: "Por receber",
  再交易: "Negocie mais",
  即可获得: "para obter",
  领取成功: "Recebido com sucesso",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Todas as atividades serão liquidadas na data de término. As recompensas expirarão depois disso.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. O rendimento obtido será creditado na sua conta de recompensas, que pode converter ou levantar a qualquer momento.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. A criptomoeda da recompensa depende da tarefa.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. A plataforma reserva-se o direito de interpretação final. Em caso de fraude em tarefas, as recompensas serão retidas e a sua conta poderá ser congelada.",
  成长学院: "Academia",
  "区块链 & 加密货币": "Blockchain & Criptomoeda",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "O seu guia completo para criptomoedas. Acompanhamo-lo na sua jornada cripto.",
  "全仓合约定单的全部保证金。":
    "Margem total para ordens de futuros com margem cruzada.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (lucro/perda não realizado - taxas - juros de financiamento) = Valor líquido / Margem utilizada * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "O lucro/perda não realizado tem impacto direto na 'margem disponível'. Se o lucro/perda não realizado aumentar, a margem disponível aumenta e vice-versa.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (Margem utilizada) + (lucro/perda não realizado - taxas - juros de financiamento)",
  "注:可继续用于开仓的保证金。":
    "Nota: Margem disponível para abrir novas posições.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (lucro/perda não realizado - taxas - juros de financiamento)",
  "注:当前的资金结余。": "Nota: Saldo atual.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Refere-se ao saldo total da conta de futuros, incluindo montantes congelados.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Nota: Quanto maior a taxa de risco, menor o risco e vice-versa.",
  该功能尚未开发: "Esta funcionalidade ainda está em desenvolvimento",
  重置密码: "Redefinir palavra-passe",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Insira 8-20 caracteres, incluindo letras, números e caracteres especiais",
  修改成功: "Alteração efetuada com sucesso",
  输入验证码: "Insira o código de verificação",
  输入密码: "Insira a palavra-passe",
  详情说明: "Detalhes",
  已售罄: "Esgotado",
  剩余期限: "Prazo restante",
  限期: "Prazo",
  闪兑货币选择: "Selecionar moeda para conversão rápida",
  地区选择: "Selecionar região",
  "搜索国家/地区": "Pesquisar país/região",
  "身份信息已提交，将在*小时内审核完成":
    "Informações de identificação submetidas. O processamento demorará até * horas.",
  "选择国家/地区": "Selecionar país/região",
  "止盈价格需高于*": "O preço de take-profit deve ser superior a *",
  "止损价格需低于*": "O preço de stop-loss deve ser inferior a *",
  "止盈价格需低于*": "O preço de take-profit deve ser inferior a *",
  "止损价格需高于*": "O preço de stop-loss deve ser superior a *",
  教程详情: "Detalhes do tutorial",
  请输入止损价: "Insira o preço de stop-loss",
  活期: "Flexível",
  赎回后立即到账: "Crédito imediato após resgate",
  赎回: "Resgatar",
  赎回理财: "Resgatar produto financeiro",
  是否赎回当前的理财订单: "Resgatar a encomenda de produto financeiro atual?",
  维护: "Manutenção",
  "系统正在维护中……": "Sistema em manutenção...",
  合约: "Futuros",
  闪电兑换: "Conversão rápida",
  流水挖矿: "Mineração de volume",
  邀请豪礼: "Bónus de convite",
  计算器: "Calculadora",
  最新价: "Último preço",
  涨跌幅: "Variação (24h)",
  关注币种添加自选: "Adicionar criptomoeda aos favoritos",
  一键添加自选: "Adicionar aos favoritos (um clique)",
  全标已读: "Marcar tudo como lido",
  无消息: "Sem mensagens",
  "暂时还没有收到任何消息通知哦!": "Ainda não recebeu nenhuma notificação!",
  没有更多数据: "Sem mais dados",
  闪兑: "Conversão rápida",
  从: "De",
  "可用余额：": "Saldo disponível:",
  至: "Para",
  预览兑换结果: "Pré-visualizar resultado da conversão",
  闪兑规则: "Regras de conversão rápida",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "A conversão rápida está sujeita a flutuações de mercado. O montante efetivamente recebido é vinculativo.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "As taxas de câmbio são definidas por terceiros. Devido a custos e flutuações, a taxa pode diferir da taxa de mercado. Verifique cuidadosamente.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "A plataforma cobra aproximadamente *% de taxa por conversão para cobrir os custos nas exchanges.",
  确认汇兑: "Confirmar conversão",
  您预估得到: "Estimativa de recebimento",
  汇兑: "Conversão",
  汇兑比例: "Taxa de câmbio",
  刷新: "Atualizar",
  兑换: "Converter",
  没有更多了: "Sem mais dados",
  搜索币种: "Pesquisar criptomoeda",
  可用: "Disponível",
  我知道了: "Compreendo",
  最新价格: "Último preço",
  确认: "Confirmar",
  最大: "Máximo",
  "风险率(%)": "Taxa de risco (%)",
  当前委托: "Ordens atuais",
  合作交易历史记录: "Histórico de transações do parceiro",
  重置: "Repor",
  余额: "Saldo",
  现货账户: "Conta spot",
  合约账户: "Conta de futuros",
  WIN账户: "Conta WIN",
  赏金账户: "Conta de recompensas",
  总资产折合: "Ativos totais (em USDT)",
  今日收益: "Rendimento de hoje",
  充币: "Depositar",
  提币: "Levantar",
  账户权益: "Valor da conta",
  "数量/类别": "Quantidade/Categoria",
  全部币种: "Todas as criptomoedas",
  全部类型: "Todos os tipos",
  账单信息: "Informações da fatura",
  理财赎回: "Resgate de produto financeiro",
  购买理财: "Comprar produto financeiro",
  收入: "Receitas",
  支出: "Despesas",
  到: "para",
  资产划转: "Transferência de ativos",
  "最少*": "Mínimo *",
  "可用资产：": "Ativos disponíveis:",
  确认划转: "Confirmar transferência",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Necessita de transferir ativos para a conta correta para poder negociar. As transferências entre contas são gratuitas.",
  币种账户选择: "Selecionar conta de criptomoeda",
  选择账户: "Selecionar conta",
  划转详情: "Detalhes da transferência",
  划转明细: "Especificações da transferência",
  收入账单: "Fatura de receitas",
  支出账单: "Fatura de despesas",
  金额: "Montante",
  总收益: "Rendimento total",
  佣金: "Comissão",
  用户名: "Nome de utilizador",
  "已领取：": "Recebido:",
  "未领取：": "Não recebido:",
  "请选择国家/地区": "Selecione o país/região",
  请上传身份信息: "Carregue as informações de identificação",
  请选择证件类型: "Selecione o tipo de documento",
  请填写证件编码: "Insira o número do documento",
  请填写名字: "Insira o nome próprio",
  请填写姓氏: "Insira o apelido",
  投资金额: "Montante de investimento",
  天: "dias",
  请输入手机号: "Insira o número de telefone",
  搜索: "Pesquisar",
  搜索历史: "Histórico de pesquisas",
  热门推荐: "Recomendações populares",
  "《Xspace Earn协议》": "Protocolo Xspace Earn",
  我已了解并同意: "Compreendo e aceito o",
  协议: "Protocolo",
  Xspace官方中文交流群: "Comunidade oficial chinesa da Xspace",
  Xspace官方英文交流群: "Comunidade oficial inglesa da Xspace",
  预计维护至: "Manutenção prevista até",
  更多功能: "Mais funcionalidades",
  下载APP: "Descarregar App",
  理财: "Produto financeiro",
  推荐: "Recomendado",
  Telegram官方中文频道: "Canal oficial do Telegram (Chinês)",
  Telegram官方英文频道: "Canal oficial do Telegram (Inglês)",
  官方邮箱: "E-mail oficial",
  客服邮箱: "E-mail de apoio ao cliente",
  上述信息最终解释权归官方所有:
    "As informações acima estão sujeitas à interpretação oficial da plataforma.",
  IOS版下载: "Descarregar para iOS",
  Android版下载: "Descarregar para Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Taxa de transação = Taxa de compra + Taxa de financiamento + Taxa de venda",
  资金划转: "Transferência de ativos",
  止盈: "Take-profit",
  止损: "Stop-loss",
  自动平仓: "Fecho automático",
  委托挂单: "Ordem aberta",
  买: "Comprar",
  卖: "Vender",
  "买入/做多": "Comprar/Long",
  "卖出/做空": "Vender/Short",
  详情: "Detalhes",
  浮动涨跌: "Lucro/Perda não realizado",
  最小: "Mínimo",
  充币数量: "Quantidade a depositar",
  请输入充币数量: "Insira a quantidade a depositar",
  支付截图: "Comprovativo de pagamento",
  提交: "Submeter",
  上传驾驶证: "Carregar carta de condução",
  上传护照: "Carregar passaporte",
  加载中: "A carregar...",
  上传成功: "Carregamento efetuado com sucesso",
  充值历史: "Histórico de depósitos",
  合约卖出手续费: "Taxa de venda de futuros",
  合约买入手续费: "Taxa de compra de futuros",
  系统加款: "Crédito de sistema",
  系统减款: "Débito de sistema",
  合约资金费率: "Taxa de financiamento de futuros",
  佣金分成: "Repartição de comissão",
  U本位合约: "Futuros com margem em USDT",
  资产管理: "Gestão de ativos",
  APP下载: "Descarregar App",
  全球领先的数字理财平台: "Plataforma financeira digital líder mundial",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Negocie imediatamente Bitcoin, Ethereum e centenas de outros ativos digitais",
  "24H涨跌幅": "Variação 24h",
  查看更多行情: "Ver mais mercados",
  近24小时成交量: "Volume 24h",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Oferece centenas de pares spot e de futuros. Mais de 20 milhões de utilizadores em mais de 200 países. Uma plataforma de ativos digitais líder mundial.",
  用户国家分布: "Utilizadores por país",
  用户数: "Número de utilizadores",
  交易对: "Pares de negociação",
  服务支持: "Apoio",
  "随时随地，多平台终端交易":
    "Negocie em qualquer lugar com suporte multiplataforma",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Compatível com vários dispositivos para todas as necessidades de negociação.",
  随时查看实时行情: "Veja cotações em tempo real em qualquer lugar",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Compre e venda facilmente BTC, ETH, DOGE e outros ativos digitais",
  获取您关注的加密货币价格变化预警:
    "Receba alertas de preço para criptomoedas que segue",
  "查看比特币现货、期货、期权价格":
    "Veja preços de Bitcoin spot, futuros e opções",
  比较各交易所加密货币价格: "Compare preços de criptomoedas entre exchanges",
  开启您的数字货币之旅: "Inicie a sua jornada com ativos digitais",
  快捷购买数字货币: "Compre criptomoedas rapidamente",
  "使用多种支付方式交易数字货币，安全快捷":
    "Negocie de forma segura e rápida com vários métodos de pagamento",
  最优的交易费率: "As melhores taxas de transação",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Taxas vantajosas, benefícios VIP competitivos e serviço de alta qualidade.",
  可信赖的安全保障: "Segurança confiável",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Medidas de segurança avançadas e o fundo SAFU protegem os seus ativos contra riscos.",
  交易: "Negociar",
  币币市场: "Mercado spot",
  "24H成交量": "Volume 24h",
  交易所: "Exchange",
  "24H最高": "Máximo 24h",
  "24H最低": "Mínimo 24h",
  永续合约: "Futuros perpétuos",
  日涨跌: "Variação diária",
  交易深度: "Profundidade da carteira de ordens",
  "资产(合约)": "Ativos (Futuros)",
  历史仓位: "Histórico de posições",
  兑换记录: "Histórico de conversões",
  类型: "Tipo",
  充值记录: "Histórico de depósitos",
  划转记录: "Histórico de transferências",
  类别: "Categoria",
  历史账单: "Histórico de faturas",
  在线充值: "Depósito online",
  安全设置: "Definições de segurança",
  用于账户登录使用: "Usado para iniciar sessão na conta",
  用户提现时安全验证使用:
    "Usado para verificação de segurança em levantamentos",
  验证: "Verificar",
  万: "milhão",
  随时随地开启交易: "Comece a negociar em qualquer lugar",
  "*货币交易所的所有功能尽在你的手中。":
    "Todas as funcionalidades da exchange * na sua mão.",
  "下载*货币交易所APP。": "Descarregue a aplicação da exchange *.",
  下载自: "Descarregar de",
  内测版: "Versão beta",
  下载: "Descarregar",
  扫码下载: "Digitalizar para descarregar",
  设置您的资产密码: "Defina a sua palavra-passe de ativos",
  法币: "Moeda fiduciária",
  我要买: "Quero comprar",
  我要卖: "Quero vender",
  请输入金额: "Insira o montante",
  汇率: "Taxa de câmbio",
  获得: "Receber",
  支付通道: "Canal de pagamento",
  收款通道: "Canal de recebimento",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Certifique-se de que o canal de recebimento está em seu nome ao vender.",
  当前法币暂不支持交易对可尝试前往提现:
    "Este par fiduciário não é suportado de momento. Tente um levantamento.",
  前往提现: "Ir para levantamento",
  该法币暂无通道: "Nenhum canal disponível para esta moeda fiduciária",
  "正在出售中，请耐心等待": "Venda em curso, por favor aguarde",
  请选择支付通道: "Selecione o canal de pagamento",
  请选择方式: "Selecione o método",
  法币历史: "Histórico fiduciário",
  买币: "Comprar cripto",
  卖币: "Vender cripto",
  失败: "Falhou",
  已完成: "Concluído",
  未付款: "Não pago",
  待审核: "Em espera",
  打款中: "Pagamento em curso",
  订单详情: "Detalhes da encomenda",
  联系客服: "Contactar apoio ao cliente",
  到账金额: "Montante recebido",
  通道: "Canal",
  收款人: "Destinatário",
  收款账户: "Conta do destinatário",
  "订单出售失败，请查下方失败原因":
    "Venda da encomenda falhou. Veja o motivo abaixo.",
  失败原因: "Motivo da falha",
  您还未进行付款: "Ainda não efetuou o pagamento",
  您已成功购买: "Compra efetuada com sucesso",
  已取消订单: "Encomenda cancelada",
  "订单正在审核中，请耐心等待":
    "Encomenda em processamento. Por favor aguarde.",
  您已成功出售: "Venda efetuada com sucesso",
  "订单正在打款中，请耐心等待": "Pagamento em curso. Por favor aguarde.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Para efetuar o pagamento, necessita de visitar outra plataforma. Preste atenção à segurança das suas informações.",
  当前法币暂不支持交易对可尝试前往充值:
    "Este par fiduciário não é suportado de momento. Tente um depósito.",
  前往充值: "Ir para depósito",
  购买: "Comprar",
  订单号: "Número da encomenda",
  单价: "Preço unitário",
  到账数量: "Quantidade recebida",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Existe uma encomenda não paga. Deseja iniciar uma nova ordem de pagamento?",
  继续支付: "Continuar a pagar",
  重新下单: "Fazer nova encomenda",
  是否确定出售: "Tem a certeza de que deseja vender?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Após confirmação, a plataforma atribuirá um comprador. Aguarde a correspondência.",
  出售: "Vender",
  收款方式: "Método de recebimento",
  订单已生成: "Encomenda gerada",
  取消订单: "Cancelar encomenda",
  请在: "Por favor, dentro de",
  内完成付款: "efetue o pagamento",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Saia da plataforma, inicie sessão no seu método de pagamento escolhido e transfira o montante para a seguinte conta do vendedor. Indique sempre a referência:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Sem referência, o vendedor não conseguirá confirmar o pagamento, o que pode levar à perda de ativos.",
  "未在规定的时间内付款，订单都将被取消。":
    "Se não pagar dentro do prazo estipulado, a encomenda será cancelada.",
  姓名: "Nome",
  收款姓名: "Nome do destinatário",
  开户支行: "Filial bancária",
  银行卡号: "Número do cartão bancário",
  "付款后，返回本平台": "Após o pagamento, regresse a esta plataforma",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Clique no botão 'Efetuei o pagamento, notificar vendedor'",
  未点击卖家不会放款:
    "O vendedor só libertará a cripto depois de clicar no botão",
  交易条款: "Termos da transação",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Os fundos para compra devem ser legais e seguros",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Fraude, esquemas em pirâmide, jogo ou outros fundos ilegais não são permitidos",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Se, após a transação, os fundos forem congelados ou suspeitos, não libertaremos os USDT e efetuaremos um reembolso",
  "已付款，通知卖家": "Pago, notificar vendedor",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Se cancelar um total de * encomendas hoje, o seu direito de compra será revogado por hoje. Cancelar esta encomenda?",
  添加收款方式: "Adicionar método de recebimento",
  是否删除此收款方式: "Eliminar este método de recebimento?",
  删除: "Eliminar",
  请选择法币: "Selecione a moeda fiduciária",
  机构名称: "Nome da instituição",
  请选择机构: "Selecione a instituição",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "O seu método de recebimento selecionado será mostrado aos compradores quando vender cripto. Certifique-se de que os dados estão corretos.",
  请选择银行: "Selecione o banco",
  请输入姓名: "Insira o nome",
  账号: "Número da conta",
  请输入账号: "Insira o número da conta",
  收款码: "Código de recebimento",
  "银行账号/卡号": "Conta bancária/Número do cartão",
  "请输入银行账号/卡号": "Insira a conta bancária/número do cartão",
  "开户支行（选填）": "Filial bancária (opcional)",
  请输入开户支行: "Insira a filial bancária",
  "加入*官方频道": "Torne-se membro do canal oficial *",
  关于: "Sobre",
  条款: "Termos",
  成功: "Sucesso",
  等待: "Aguardar",
  作废: "Inválido",
  确认付款: "Confirmar pagamento",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Pagamento concluído? Após confirmação, o vendedor verificará o recebimento dentro de * minutos.",
  最大金额: "Montante máximo",
  最小金额: "Montante mínimo",
  付款: "Pagar",
  法币充值: "Depositar moeda fiduciária",
  法币提现: "Levantar moeda fiduciária",
  待支付: "Por pagar",
  已支付: "Pago",
  商户名: "Nome do vendedor",
  当前没有添加支付方式: "Nenhum método de pagamento adicionado",
  添加后再出售: "Adicione um antes de vender",
  新人大礼包: "Pacote de boas-vindas",
  注册即可领取: "Receba após o registo",
  立即领取: "Receber agora",
  不再提示: "Não voltar a mostrar",
  "该奖励需在APP中领取，请下载APP":
    "Esta recompensa só pode ser recebida na aplicação. Descarregue a aplicação.",
  去交易: "Ir negociar",
  期权交易: "Negociação de opções",
  交易额: "Montante de negociação",
  可用额度: "Limite disponível",
  交易周期: "Período de negociação",
  看涨: "Alta (Call)",
  看跌: "Baixa (Put)",
  看空: "Venda a descoberto (Short)",
  当前持有: "Posição atual",
  胜率: "Taxa de acerto",
  "盈利/亏损数": "Número de transações com lucro/perda",
  累计实现盈亏: "Lucro/Perda total realizado",
  秒: "segundos",
  分: "minutos",
  小时: "horas",
  周: "semana",
  下单时间: "Data da encomenda",
  剩余时间: "Tempo restante",
  买入价: "Preço de compra",
  结算价: "Preço de liquidação",
  实现盈利: "Lucro realizado",
  结算时间: "Data de liquidação",
  期权: "Opção",
  新手教程: "Guia para iniciantes",
  我的订单: "As minhas encomendas",
  赔率: "Probabilidade",
  全部订单: "Todas as encomendas",
  持有订单: "Encomendas abertas",
  历史订单: "Histórico de encomendas",
  输入交易额度: "Insira o montante de negociação",
  选择交易周期: "Selecione o período de negociação",
  去注册: "Registar",
  冻结: "Congelar",
  期权支出: "Despesa de opção",
  期权收入: "Receita de opção",
  用户提现: "Levantamento do utilizador",
  "是否购买？": "Comprar esta opção?",
  购买成功: "Compra efetuada com sucesso",
  请签名: "Por favor, assine",
  提交签名: "Submeter assinatura",
  清空签名: "Limpar assinatura",
  签名审核中: "Assinatura em verificação",
  已提交: "Submetido",
  扫一扫下载APP: "Digitalize para descarregar a aplicação",
  新手领取大礼包: "Pacote de boas-vindas para novos utilizadores",
  注册实名即送彩金: "Registe-se e verifique-se para receber um bónus",
  交易总额: "Volume total de negociação",
  资产不足: "Ativos insuficientes",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Ativos insuficientes na conta WIN. Pode transferir ativos da sua conta principal.",
  Win: "WIN",
  比赛: "Competição",
  未开始: "Não iniciado",
  赛程: "Calendário",
  赛果: "Resultado",
  已结束: "Terminado",
  让球: "Handicap",
  进球数: "Golos",
  大: "Mais de (Over)",
  小: "Menos de (Under)",
  胜负平: "1X2 (Vitória/Empate/Derrota)",
  和局: "Empate",
  投注: "Aposta",
  下注金额: "Montante da aposta",
  下注: "Apostar",
  阵容: "Alinhamento",
  分析: "Análise",
  输入下注金额: "Insira o montante da aposta",
  下注成功: "Aposta efetuada com sucesso",
  投注记录: "Histórico de apostas",
  未结算: "Não liquidado",
  已结算: "Liquidado",
  流水: "Volume",
  输赢: "Lucro/Perda",
  赛时: "Hora do jogo",
  下注时间: "Data da aposta",
  足彩竞猜: "Aposta de futebol",
  查看详情: "Ver detalhes",
  输: "Perda",
  赢: "Lucro",
  主: "Casa",
  客: "Fora",
  主胜: "Vitória em casa",
  客胜: "Vitória fora",
  平: "Empate",
  已延期: "Adiado",
  账号异常: "Anomalia na conta",
  全场独赢: "1X2 Tempo integral",
  全场让球: "Handicap tempo integral",
  全场大小: "Mais/Menos tempo integral",
  总进球: "Total de golos",
  拍摄照片要求: "Requisitos da foto",
  标准拍摄: "Foto padrão",
  边框缺失: "Borda ausente",
  照片模糊: "Foto desfocada",
  闪光强烈: "Flash muito forte",
  上传手持证件照: "Carregar foto com documento na mão",
  上传证件照: "Carregar foto do documento",
  换一张: "Nova foto",
  出生日期: "Data de nascimento",
  请选择出生日期: "Selecione a data de nascimento",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Insira o código de verificação abaixo para obter um código por e-mail para se registar.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Ainda tem * tentativas de verificação. Após esse limite, não poderá verificar-se.",
  上半场: "1.ª parte",
  下半场: "2.ª parte",
  独赢: "1X2",
  上半场独赢: "1.ª parte 1X2",
  下半场独赢: "2.ª parte 1X2",
  上半场让球: "1.ª parte Handicap",
  下半场让球: "2.ª parte Handicap",
  上半场大小球: "1.ª parte Mais/Menos",
  下半场大小球: "2.ª parte Mais/Menos",
  波胆: "Resultado exato",
  上半场波胆: "1.ª parte Resultado exato",
  下半场波胆: "2.ª parte Resultado exato",
  单双: "Par/Ímpar",
  单: "Ímpar",
  双: "Par",
  上半场单双: "1.ª parte Par/Ímpar",
  下半场单双: "2.ª parte Par/Ímpar",
  上半场总进球: "1.ª parte Total de golos",
  下半场总进球: "2.ª parte Total de golos",
  中场: "Intervalo",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Atenção: Para a foto com o documento na mão, escreva o texto numa folha de papel branca e fotografe-a juntamente com o seu documento, como no exemplo.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Recentemente, muitas contas fraudulentas foram punidas. Contacte o apoio ao cliente se acredita que a sua conta foi punida injustamente.",
  最小下注金额: "Aposta mínima",
  参与活动最小下注金额: "Aposta mínima para participar na atividade",
  记住密码: "Lembrar palavra-passe",
  比分: "Resultado",
  "您还未登录，请先登录": "Não iniciou sessão. Inicie sessão primeiro.",
  立即登录: "Iniciar sessão agora",
  下注限额: "Limite de aposta",
  可赢金额: "Montante a ganhar",
  闪兑详情: "Detalhes da conversão rápida",
  大小球: "Mais/Menos",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Devido a flutuações cambiais, o montante final da aposta pode diferir. A encomenda é vinculativa.",
  开赛时间: "Hora de início",
  足球收入: "Receitas de futebol",
  足球支出: "Despesas de futebol",
  活动详情: "Detalhes da atividade",
  为世界杯喝彩: "Apoie o Mundial",
  我的竞猜: "Os meus palpites",
  "竞猜比赛、有机会瓜分*USDT":
    "Palpite em jogos e tenha a chance de ganhar uma parte de * USDT",
  "瓜分*USDT": "Repartir * USDT",
  距离活动结束还有: "Fim da atividade em:",
  我的门票: "Os meus bilhetes",
  竞猜结束时间: "Fim dos palpites",
  猜比分: "Palpite no resultado",
  "福利派送中，完成任务即可获取门票":
    "Bónus a serem distribuídos. Conclua tarefas para ganhar bilhetes.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Conclua as seguintes tarefas para obter o número correspondente de bilhetes para participar na competição.",
  时: "hora",
  活动: "Atividade",
  竞猜记录: "Histórico de palpites",
  结果: "Resultado",
  任务: "Tarefa",
  去邀请: "Convidar",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Palpite no resultado de cada jogo e tenha a chance de ganhar uma parte de $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "É necessário um bilhete para palpitar. Os bilhetes podem ser ganhos ao concluir tarefas da plataforma.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Após um palpite bem-sucedido, envie um print para o apoio ao cliente. Eles creditarão o bónus na sua conta, que pode levantar imediatamente.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Fraude é proibida. Se detetada, a recompensa será anulada.",
  "完成任务后，点击咨询客服获得门票。":
    "Após concluir as tarefas, clique em 'Contactar apoio ao cliente' para obter bilhetes.",
  继续猜: "Continuar a palpitar",
  总单数: "Número total de apostas",
  赛事筛选: "Filtrar por evento",
  球队筛选: "Filtrar por equipa",
  总金额: "Montante total",
  总流水: "Volume total",
  派奖金额: "Montante do bónus atribuído",
  下注单数: "Número de apostas",
  利润: "Lucro",
  更多福利: "Mais bónus",
  我的奖金: "O meu bónus",
  未认证: "Não verificado",
  总量: "Total",
  或: "ou",
  模拟交易: "Negociação simulada",
  体验账户不可操作: "Não disponível na conta de demonstração",
  世界杯比分竞猜: "Palpite no resultado do Mundial",
  "领*USDT起": "Receba a partir de * USDT",
  消息: "Mensagens",
  滚球: "Apostas ao vivo",
  是: "Sim",
  不是: "Não",
  当前余额: "Saldo atual",
  KOL招募: "Recrutamento KOL",
  本月净输赢: "Lucro/Perda líquido este mês",
  本月佣金: "Comissão este mês",
  佣金比例: "Percentagem de comissão",
  活跃人数: "Utilizadores ativos",
  新增下级: "Novos subordinados",
  登录人数: "Utilizadores com sessão iniciada",
  首存人数: "Utilizadores com primeiro depósito",
  数据分析: "Análise de dados",
  人数: "Número de pessoas",
  新注册存款金额: "Montante depositado por novos registos",
  老用户存款金额: "Montante depositado por utilizadores existentes",
  首存金额: "Montante do primeiro depósito",
  快捷入口: "Acesso rápido",
  成员管理: "Gestão de membros",
  财务报表: "Relatórios financeiros",
  分红报表: "Relatório de dividendos",
  订单记录: "Histórico de encomendas",
  VIP专享: "Exclusivo VIP",
  推广工具: "Ferramentas de promoção",
  计算规则: "Regras de cálculo",
  账变明细: "Detalhes da transação",
  成员: "Membros",
  下级概览: "Visão geral dos subordinados",
  下级成员总计: "Total de subordinados",
  本月新增: "Novos este mês",
  本月活跃会员: "Membros ativos este mês",
  今日活跃会员: "Membros ativos hoje",
  本月有效活跃: "Ativo efetivo este mês",
  活跃成员占比: "Percentagem de membros ativos",
  本月活跃: "Ativo este mês",
  今日活跃: "Ativo hoje",
  下级成员: "Subordinados",
  会员账号: "Conta do membro",
  统计时间: "Data da estatística",
  筛选: "Filtrar",
  存款: "Depósito",
  取款: "Levantamento",
  总输赢: "Lucro/Perda total",
  是否有效用户: "Utilizador ativo?",
  最近登录时间: "Último início de sessão",
  否: "Não",
  开始时间: "Hora de início",
  结束时间: "Hora de fim",
  提取: "Levantar",
  总盈亏: "Resultado total",
  净盈亏: "Resultado líquido",
  分红: "Dividendo",
  概览: "Visão geral",
  月度详细数据: "Dados mensais detalhados",
  未发放: "Não atribuído",
  活跃用户: "Utilizadores ativos",
  有效新增会员: "Novos membros efetivos",
  冲正后净输赢: "Lucro/Perda líquido após correção",
  上月结余: "Saldo do mês anterior",
  净输赢: "Lucro/Perda líquido",
  "系统每日新加坡时间1:00更新一次报表":
    "Os relatórios são atualizados diariamente às 01:00 hora de Singapura.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Nos relatórios, números positivos significam lucro para o parceiro, números negativos significam perda para o parceiro.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Os dados de comissão são atualizados diariamente, são indicativos e não constituem uma base de pagamento definitiva.",
  选择时间: "Selecionar tempo",
  足球: "Futebol",
  投注金额: "Montante da aposta",
  有效订单: "Encomendas válidas",
  下级账户: "Conta subordinada",
  待成交: "Em espera",
  下单金额: "Montante da encomenda",
  订单内容: "Conteúdo da encomenda",
  秒数: "Segundos",
  联赛: "Liga",
  队伍: "Equipa",
  比赛时间: "Hora do jogo",
  玩法: "Tipo de aposta",
  等级规则表: "Tabela de regras de nível",
  等级: "Nível",
  活跃会员: "Membros ativos",
  最新活跃: "Atividade mais recente",
  额外佣金: "Comissão extra",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Mensalmente com base em padrões de crescimento. Só pode beneficiar de um nível.",
  渠道生成: "Gerar canal",
  创建: "Criar",
  渠道名称: "Nome do canal",
  注册人数: "Número de registos",
  浏览人数: "Número de visualizações",
  构建状态: "Estado da construção",
  禁用: "Desativar",
  启用: "Ativar",
  查看: "Ver",
  创建渠道: "Criar canal",
  创建成功: "Criação efetuada com sucesso",
  操作成功: "Ação efetuada com sucesso",
  渠道详情: "Detalhes do canal",
  邀请码: "Código de convite",
  访问人数: "Número de visitantes",
  渠道地址: "Endereço do canal",
  我的福利: "Os meus bónus",
  充值福利: "Bónus de depósito",
  当前流水: "Volume atual",
  如何参与: "Como participar",
  币种充值: "Depósito de criptomoeda",
  充值福利中领取福利: "Receber bónus no bónus de depósito",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regra: O bónus de depósito é voluntário, válido por 24 horas após o depósito. Após o recebimento, o levantamento é temporariamente bloqueado até que o requisito de volume seja atingido.",
  失效日期: "Data de validade",
  "暂无福利领取，充值后领取": "Nenhum bónus disponível. Receba após depósito.",
  参与: "Participar",
  充值赠送: "Bónus de depósito",
  "领取*%的赠送": "Receba *% de bónus",
  去领取: "Receber",
  VIP奖励: "Recompensa VIP",
  "当前可领取*USDT，是否确认领取": "* USDT disponível para receber. Confirmar?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Após o recebimento, o levantamento é temporariamente bloqueado até que um volume de * USDT seja atingido.",
  充值送大礼: "Oferta de depósito",
  "存入越多，送越多！": "Quanto mais depositar, maior a oferta!",
  无效: "Inválido",
  有效: "Válido",
  总存金额: "Montante total depositado",
  提示: "Aviso",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Números positivos no lucro/perda total e líquido significam lucro da plataforma. Os dados diários são indicativos.",
  "净盈亏：总盈亏-用户返水":
    "Resultado líquido: Resultado total - Cashback ao utilizador",
  盈利方: "Parte com lucro",
  代理: "Agente",
  客户: "Cliente",
  平局: "Empate",
  平台: "Plataforma",
  "已提交审核，请耐心等待": "Submetido para verificação. Por favor aguarde.",
  充值日期: "Data do depósito",
  平台本月总输赢: "Lucro/Perda total da plataforma este mês",
  KOL招募合作: "Colaboração de recrutamento KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "A plataforma abre o recrutamento KOL. Com uma conta de redes sociais, pode usufruir de dividendos e receitas vitalícias através da angariação de clientes única.",
  级别: "Nível",
  平台利润返佣: "Comissão de lucro da plataforma",
  佣金案例: "Exemplo de comissão",
  交易项目: "Produtos de negociação",
  "期权交易、合约交易、足球游戏":
    "Negociação de opções, negociação de futuros, jogos de futebol",
  报名方式: "Método de inscrição",
  点击KOL招募报名: "Clique para se inscrever no recrutamento KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Bem-vindo à nossa equipa. Apoiamo-lo na construção do seu próprio sistema de utilizadores. Ganhe até *% de comissão. Aguardamos a sua participação.",
  输入联系方式: "Insira os contactos",
  最低活跃人数: "Número mínimo de utilizadores ativos",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Ex.: Se utilizadores ativos este mês ≥ * e lucro/perda total da plataforma ≥ * USDT, está no nível * e recebe *% de comissão.",
  比分竞猜: "Palpite no resultado",
  豪礼相赠: "Grande oferta",
  足球活动: "Atividade de futebol",
  圣诞节活动: "Atividade de Natal",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Participou numa atividade. O levantamento está temporariamente bloqueado. Ainda necessita de * USDT de volume para desbloquear.",
  剩余流水: "Volume restante",
  助力足球: "Apoie o futebol",
  佣金累计: "Comissão total",
  有效投注: "Apostas válidas",
  今日: "Hoje",
  今日返水: "Cashback hoje",
  VIP返水: "Cashback VIP",
  返水记录: "Histórico de cashback",
  成员信息: "Informações do membro",
  基本信息: "Informações básicas",
  钱包余额: "Saldo da carteira",
  投注信息: "Informações da aposta",
  返水: "Cashback",
  总下注: "Aposta total",
  今日输赢: "Lucro/Perda hoje",
  下注动态: "Atividade de apostas",
  返水奖励: "Recompensa de cashback",
  分红金额: "Montante do dividendo",
  返水支出: "Despesa de cashback",
  总返水: "Cashback total",
  流水总额: "Volume total",
  返水总额: "Cashback total",
  返水详情: "Detalhes do cashback",
  日流水: "Volume diário",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "A plataforma oferece cashback extra com base no volume diário dos seus subordinados. Pagamento diário às 00:00 hora de Singapura para a conta de recompensas.",
  "申请成功，等待审核": "Pedido efetuado com sucesso, aguarde verificação",
  "我出本金，盈利共分享": "Eu forneço o capital, o lucro é partilhado",
  最高分红: "Dividendo máximo",
  投资大师比赛: "Competição Mestre Investidor",
  "我出本金，你盈利": "Eu forneço o capital, tu lucras",
  共分享: "Partilhar juntos",
  最高分红可得: "Dividendo máximo possível",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Bónus exclusivo de boas-vindas: $* grátis. Após receber, pode investir em qualquer projeto. O lucro é imediatamente levantável.",
  报名领取: "Inscrever-se e receber",
  审核驳回: "Verificação rejeitada",
  驳回原因: "Motivo da rejeição",
  活动运行周期: "Período da atividade",
  "申请成功后起至*天内完成超额收益。":
    "Obtenha rendimento excedente dentro de * dias após a aprovação.",
  分红比: "Proporção do dividendo",
  "*日获得盈利后，可获得*%的收益额。":
    "Após obter lucro no dia *, recebe *% do montante do rendimento.",
  参与条件: "Condições de participação",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Utilizadores da Rússia ou Turquia que ainda não participaram.",
  计算项目: "Produtos calculados",
  "合约、体育、期权": "Futuros, Desporto, Opções",
  我的投资: "Os meus investimentos",
  参与天数: "Dias de participação",
  累计下注: "Aposta total",
  累计盈亏: "Lucro/Perda total",
  预计可分红: "Dividendo esperado",
  常见问题: "Perguntas frequentes (FAQ)",
  什么是平台出资: "O que é o financiamento da plataforma?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "A plataforma fornece fundos gratuitos a utilizadores de determinados países para investirem em projetos.",
  怎么获取平台出资的福利: "Como obter o bónus de financiamento da plataforma?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Se for de um dos países designados, clique no botão de inscrição. Após aprovação, * USDT serão transferidos para a sua conta de recompensas, que pode transferir para investir.",
  什么是分红: "O que é um dividendo?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividendo: Se dentro do prazo estipulado o rendimento atingir 100%, recebe 50% do rendimento excedente. Ex.: Recebe 100 USDT, obtém 120% de rendimento, então 20% é excedente.",
  "如何取得分红？": "Como obter o dividendo?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "O ciclo da atividade é a cada * dias. Após o término, é feito o cálculo. Se cumprir os requisitos, o dividendo é enviado para a conta de recompensas. Se não cumprir, o seu rendimento e o financiamento da plataforma serão removidos.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "As contas participantes devem ser verificadas com KYC. Apenas um bónus por conta.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "O KYC para participação só é válido para países designados. Verifique se o seu país corresponde ao país da atividade.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Após a participação bem-sucedida, o levantamento é temporariamente bloqueado até a atividade ser concluída.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Cumpra as regras da atividade. Em caso de fraude ou abuso de falhas do sistema, todos os ativos na sua conta serão permanentemente congelados.",
  平台出资: "Financiamento da plataforma",
  平台出资收回: "Financiamento da plataforma retirado",
  投资大师奖励: "Recompensa Mestre Investidor",
  请下载APP添加收款方式:
    "Descarregue a aplicação para adicionar um método de recebimento",
  请下载APP进行身份验证:
    "Descarregue a aplicação para efetuar a verificação de identidade",
  请下载APP参与: "Descarregue a aplicação para participar",
  技术指标: "Indicadores técnicos",
  主图: "Gráfico principal",
  副图: "Gráfico secundário",
  新注册人数: "Novos registos",
  老用户存款人数: "Utilizadores existentes que depositam",
  存款人数: "Número de depósitos",
  取款人数: "Número de levantamentos",
  投注人数: "Número de apostas",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Excluindo utilizadores da Indonésia, Índia, Bangladesh que ainda não participaram.",
  市场动态: "Dinâmica do mercado",
  外汇合约: "Futuros Forex",
  盈亏比: "Rácio lucro/perda",
  委托价: "Preço da ordem",
  可用余额: "Saldo disponível",
  持仓额: "Valor da posição",
  强平价: "Preço de liquidação",
  修改: "Modificar",
  修改价位: "Modificar preço",
  外汇: "Forex",
  外汇账户: "Conta Forex",
  我的交易: "As minhas transações",
  未设置: "Não definido",
  超出最大可设数值: "Excede o valor máximo definível",
  超出最小可设数值: "Fica aquém do valor mínimo definível",
  止盈超出最小可设数值: "Take-profit fica aquém do valor mínimo definível",
  止损超出最大可设数值: "Stop-loss excede o valor máximo definível",
  止盈超出最大可设数值: "Take-profit excede o valor máximo definível",
  止损超出最小可设数值: "Stop-loss fica aquém do valor mínimo definível",
  挖矿: "Mineração",
  交易账户: "Conta de negociação",
  买涨: "Comprar (Alta)",
  买跌: "Vender (Baixa)",
  请输入正确的银行卡信息: "Insira os dados corretos do cartão bancário",
  联系在线客服: "Contactar apoio ao cliente online",
  法币交易请联系在线客服:
    "Contacte o apoio ao cliente para negociação com moeda fiduciária",
  提交订单: "Submeter encomenda",
  "支付过程如有疑问,请联系在线客服":
    "Contacte o apoio ao cliente se tiver dúvidas sobre o processo de pagamento",
  彩金赠送: "Atribuição de bónus",
  在线客服: "Chat ao vivo",
  最少投资: "Investimento mínimo",
  "提交时间:": "Hora de submissão:",
  提现拒绝: "Levantamento recusado",
  认证拒绝: "Verificação recusada",
  认证通过: "Verificação aprovada",
  请输入正确的交易额度: "Insira um montante de negociação válido",
  最大下注金额: "Aposta máxima",
  手机号: "Número de telefone",
  邮箱注册: "Registar com e-mail",
  手机号注册: "Registar com telefone",
  查询: "Consultar",
  手机号登录: "Iniciar sessão com telefone",
  邮箱登录: "Iniciar sessão com e-mail",
  请输入数量: "Insira a quantidade",
  可用数量: "Quantidade disponível",
  钱包登录: "Iniciar sessão com carteira",
  请输入正确的邀请码: "Insira um código de convite válido",
  "请输入邀请码(必填)": "Insira o código de convite (obrigatório)",
  输入正确的金额: "Insira um montante válido",
  法币充值: "Depositar moeda fiduciária",
  卢比充值: "Depositar Rupia indiana",
  请输入法币: "Insira o montante fiduciário",
  请输入IFSC: "Insira o código IFSC",
  "银行编码(选填)": "Código bancário (opcional)",
  请输入银行编码: "Insira o código bancário",
  请输入大于8位数的密码: "Insira uma palavra-passe com mais de 8 caracteres",
  添加成功: "Adicionado com sucesso",
  "60秒": "60 segundos",
  "180秒": "180 segundos",
  "300秒": "300 segundos",
  "2次密码不一致": "As palavras-passe não coincidem",
  输入提币数量: "Insira a quantidade a levantar",
  图片格式不正确: "Formato de imagem inválido",
  图片大于20M: "A imagem tem mais de 20 MB",
  请设置委托价格: "Defina um preço para a ordem",
  输入资金密码: "Insira a palavra-passe de ativos",
  验证码错误: "Código de verificação incorreto",
  充值拒绝: "Depósito recusado",
  请输入SSN: "Insira o SSN",
  结算完成: "Liquidação concluída",
  继续下单: "Continuar a encomendar",
  限价: "Ordem limitada",
  买入价格: "Preço de compra",
  买入量: "Quantidade a comprar",
  卖出价格: "Preço de venda",
  卖出量: "Quantidade a vender",
  买入: "Comprar",
  卖出: "Vender",
  订单创建成功: "Encomenda criada com sucesso",
  币币买入支出: "Despesa de compra spot",
  币币买入支出退还: "Reembolso de despesa de compra spot",
  币币买入获得: "Recebimento de compra spot",
  币币卖出支出: "Despesa de venda spot",
  币币卖出支出退还: "Reembolso de despesa de venda spot",
  币币卖出获得: "Recebimento de venda spot",
  币币交易手续费: "Taxa de transação spot",
  请输入限价: "Insira o preço limite",
  成交: "Executado",
  等待成交: "A aguardar execução",
  交易完成: "Transação concluída",
  被取消: "Cancelado",
  交易时间: "Hora da transação",
  法币交易: "Negociação fiduciária",
  法币出售: "Venda fiduciária",

  两次密码不一致: "As palavras-passe não coincidem",
  再次输入账户密码: "Insira novamente a palavra-passe da conta",

  美国: "Estados Unidos",
  韩国: "Coreia do Sul",
  阿尔巴尼亚: "Albânia",
  津巴布韦: "Zimbabué",
  赞比亚: "Zâmbia",
  也门: "Iémen",
  美属维尔京群岛: "Ilhas Virgens Americanas",
  英属处女群岛: "Ilhas Virgens Britânicas",
  越南: "Vietname",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbequistão",
  乌拉圭: "Uruguai",
  英国: "Reino Unido",
  阿拉伯联合酋长国: "Emirados Árabes Unidos",
  乌克兰: "Ucrânia",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Ilhas Turcas e Caicos",
  土库曼斯坦: "Turquemenistão",
  土耳其: "Turquia",
  突尼斯: "Tunísia",
  特立尼达和多巴哥: "Trindade e Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Timor-Leste",
  泰国: "Tailândia",
  坦桑尼亚: "Tanzânia",
  塔吉克斯坦: "Tajiquistão",
  中国台湾: "Taiwan",
  叙利亚: "Síria",
  瑞士: "Suíça",
  瑞典: "Suécia",
  斯威士兰: "Essuatíni",
  苏里南: "Suriname",
  苏丹: "Sudão",
  斯里兰卡: "Sri Lanca",
  西班牙: "Espanha",
  南非: "África do Sul",
  索马里: "Somália",
  所罗门群岛: "Ilhas Salomão",
  斯洛文尼亚: "Eslovénia",
  斯洛伐克: "Eslováquia",
  "圣马丁岛（荷兰部分）": "São Martinho (parte holandesa)",
  新加坡: "Singapura",
  塞拉利昂: "Serra Leoa",
  塞舌尔: "Seicheles",
  塞尔维亚: "Sérvia",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Arábia Saudita",
  圣多美和普林西比: "São Tomé e Príncipe",
  圣马力诺: "São Marinho",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "São Cristóvão e Neves",
  圣文森特和格林纳丁斯: "São Vicente e Granadinas",
  圣彼埃尔和密克隆岛: "São Pedro e Miquelon",
  圣露西亚: "Santa Lúcia",
  圣基茨和尼维斯: "São Cristóvão e Neves",
  卢旺达: "Ruanda",
  俄罗斯: "Rússia",
  罗马尼亚: "Roménia",
  留尼汪: "Reunião",
  刚果共和国: "República do Congo",
  卡塔尔: "Catar",
  波多黎各: "Porto Rico",
  葡萄牙: "Portugal",
  波兰: "Polónia",
  菲律宾: "Filipinas",
  秘鲁: "Peru",
  巴拉圭: "Paraguai",
  巴布亚新几内亚: "Papua-Nova Guiné",
  巴拿马: "Panamá",
  巴勒斯坦: "Palestina",
  帕劳: "Palau",
  巴基斯坦: "Paquistão",
  阿曼: "Omã",
  挪威: "Noruega",
  尼日利亚: "Nigéria",
  尼日尔: "Níger",
  尼加拉瓜: "Nicarágua",
  新西兰: "Nova Zelândia",
  新喀里多尼亚: "Nova Caledónia",
  荷属安德列斯群岛: "Antilhas Holandesas",
  荷兰: "Países Baixos",
  尼泊尔: "Nepal",
  纳米比亚: "Namíbia",
  缅甸: "Myanmar",
  莫桑比克: "Moçambique",
  摩洛哥: "Marrocos",
  蒙特塞拉特岛: "Monserrate",
  黑山: "Montenegro",
  蒙古: "Mongólia",
  摩纳哥: "Mónaco",
  摩尔多瓦: "Moldávia",
  墨西哥: "México",
  马约特: "Mayotte",
  毛里求斯: "Maurícia",
  毛里塔尼亚: "Mauritânia",
  马里亚纳群岛: "Ilhas Marianas",
  马提尼克: "Martinica",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldivas",
  马来西亚: "Malásia",
  马拉维: "Malawi",
  马达加斯加: "Madagáscar",
  马其顿: "Macedónia do Norte",
  中国澳门: "Macau",
  卢森堡: "Luxemburgo",
  立陶宛: "Lituânia",
  列支敦士登: "Listenstaine",
  利比亚: "Líbia",
  利比里亚: "Libéria",
  莱索托: "Lesoto",
  黎巴嫩: "Líbano",
  拉脱维亚: "Letónia",
  老挝: "Laos",
  吉尔吉斯斯坦: "Quirguistão",
  科威特: "Kuwait",
  基里巴斯: "Quiribáti",
  肯尼亚: "Quénia",
  哈萨克斯坦: "Cazaquistão",
  约旦: "Jordânia",
  日本: "Japão",
  牙买加: "Jamaica",
  象牙海岸: "Costa do Marfim",
  意大利: "Itália",
  以色列: "Israel",
  爱尔兰: "Irlanda",
  伊拉克: "Iraque",
  伊朗: "Irão",
  印度尼西亚: "Indonésia",
  印度: "Índia",
  冰岛: "Islândia",
  匈牙利: "Hungria",
  中国香港: "Hong Kong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guiana",
  几内亚比绍共和国: "Guiné-Bissau",
  几内亚: "Guiné",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadalupe",
  格林纳达: "Granada",
  格陵兰岛: "Gronelândia",
  希腊: "Grécia",
  直布罗陀: "Gibraltar",
  加纳: "Gana",
  德国: "Alemanha",
  格鲁吉亚: "Geórgia",
  冈比亚: "Gâmbia",
  加蓬: "Gabão",
  法属波利尼西亚: "Polinésia Francesa",
  法属圭亚那: "Guiana Francesa",
  法国: "França",
  芬兰: "Finlândia",
  斐济: "Fiji",
  法罗群岛: "Ilhas Faroé",
  埃塞俄比亚: "Etiópia",
  爱沙尼亚: "Estónia",
  厄立特里亚: "Eritreia",
  赤道几内亚: "Guiné Equatorial",
  萨尔瓦多: "El Salvador",
  埃及: "Egito",
  厄瓜多尔: "Equador",
  多米尼加共和国: "República Dominicana",
  多米尼加: "Dominica",
  吉布提: "Djibouti",
  丹麦: "Dinamarca",
  捷克: "Chéquia",
  塞浦路斯: "Chipre",
  库拉索: "Curaçau",
  古巴: "Cuba",
  克罗地亚: "Croácia",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Costa do Marfim",
  库克群岛: "Ilhas Cook",
  科摩罗: "Comores",
  哥伦比亚: "Colômbia",
  智利: "Chile",
  乍得: "Chade",
  中非共和国: "República Centro-Africana",
  佛得角: "Cabo Verde",
  开曼群岛: "Ilhas Caimão",
  开普: "Cabo",
  加拿大: "Canadá",
  喀麦隆: "Camarões",
  柬埔寨: "Camboja",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgária",
  文莱: "Brunei",
  巴西: "Brasil",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bósnia e Herzegovina",
  玻利维亚: "Bolívia",
  不丹: "Butão",
  百慕大群岛: "Bermudas",
  贝宁: "Benim",
  伯利兹: "Belize",
  比利时: "Bélgica",
  白俄罗斯: "Bielorrússia",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Barém",
  巴哈马: "Baamas",
  阿塞拜疆: "Azerbaijão",
  奥地利: "Áustria",
  澳大利亚: "Austrália",
  阿鲁巴: "Aruba",
  亚美尼亚: "Arménia",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antígua e Barbuda",
  安圭拉: "Anguila",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Samoa Americana",
  阿尔及利亚: "Argélia",
  中国: "China",
  余额不足: "Saldo insuficiente",
  最低购买: "Compra mínima",
  最高购买: "Compra máxima",
  下单成功: "Encomenda efetuada com sucesso",
  平仓成功: "Posição fechada com sucesso",
  请输入正确的平仓数量: "Insira uma quantidade de fecho válida",
  加仓成功: "Aumento de posição efetuado com sucesso",
  请输入正确的加仓金额: "Insira um montante válido para aumentar a posição",
  收藏成功: "Adicionado aos favoritos",
  取消收藏成功: "Removido dos favoritos",
  加密币永续: "Perpétuo de criptomoeda",
  外汇永续: "Perpétuo Forex",
  期权账户: "Conta de opções",
  快捷卖币: "Vender cripto rapidamente",

  托管资金: "Ativos sob gestão",
  托管中: "Em gestão",
  预计日收益: "Rendimento diário estimado",
  累计收益: "Rendimento total",
  周期: "Prazo",
  日收益: "Rendimento diário",
  限额: "Limite",
  立即托管: "Iniciar gestão agora",
  "已鎖定 請聯繫客服": "Bloqueado. Contacte o apoio ao cliente.",
  产品列表: "Lista de produtos",
  规则: "Regras",
  创建订单: "Criar encomenda",
  产品名称: "Nome do produto",
  托管周期: "Período de gestão",
  等级限制: "Restrição de nível",
  托管金额: "Montante sob gestão",
  限额: "Limite",
  余额: "Saldo",
  购买日: "Data de compra",
  起息日: "Início da contagem de juros",
  派息时间: "Hora de pagamento de juros",
  每天: "Diariamente",
  计息结束日: "Data de fim de juros",
  每日收益: "Rendimento diário",
  预计收益: "Rendimento estimado",
  "收益将自动发送至您的余额账户;":
    "O rendimento será enviado automaticamente para o saldo da sua conta;",
  "您的资金没有任何风险;": "Os seus fundos não correm qualquer risco;",
  "365*24小时不断地工作;":
    "Funciona 24 horas por dia, 7 dias por semana, 365 dias por ano;",
  托管中: "Em gestão",
  结束: "Terminado",
  今日收益: "Rendimento hoje",
  剩余周期: "Prazo restante",
  进行中: "Ativo",
  已发放: "Pago",
  信誉分: "Pontuação de reputação",

  复制成功: "Copiado com sucesso",
  VIP权益: "Benefícios VIP",
  旧密码: "Senha antiga",
  请输入旧密码: "Digite a senha antiga",
  "忘记旧密码请联系客服重置。":
    "Se você esqueceu sua senha antiga, entre em contato com o atendimento ao cliente para redefini-la.",
  去升级: "Atualizar",
  描述: "Descrição",
  实际存款金额: "Valor real do depósito",
  升级礼金: "Bônus de atualização",
  隔夜利息: "Juros overnight (swap)",
  自动结算: "Liquidação automática",
  等级规则: "Regras de nível",
  "WEB3.0币持有数据收益": "Rendimento de dados de detenção de moedas WEB3.0",
  总生产: "Produção total",
  有效节点: "Nós ativos",
  参与人: "Participantes",
  用户收益: "Rendimento do usuário",
  "流动性WEB3.0输出": "Saída de liquidez WEB3.0",
  总资产: "Ativos totais",

  ETHAI持有数据收益: "Rendimento dos dados de detenção de ETHAI",
  AI量化流动性: "Liquidez quantitativa de IA",
  现货买入手续费: "Taxa de compra à vista",
  现货支出: "Despesa à vista",
  现货资金费率: "Taxa de financiamento à vista",
  现货卖出手续费: "Taxa de venda à vista",
  现货收入: "Receita à vista",
  外汇合约支出: "Despesa de contrato de câmbio",
  外汇合约买入手续费: "Taxa de compra de contrato de câmbio",
  外汇合约资金费率: "Taxa de financiamento de contrato de câmbio",
  外汇合约卖出手续费: "Taxa de venda de contrato de câmbio",
  外汇合约收入: "Receita de contrato de câmbio",
  理财购买: "Compra de produto financeiro",
  VIP理财日收益: "Rendimento diário do produto financeiro VIP",
  VIP理财隔夜利息: "Juro overnight do produto financeiro VIP",
  VIP本金返还: "Devolução do capital VIP",
  VIP彩金发放: "Distribuição de bónus VIP",
  VIP彩金抵扣: "Dedução de bónus VIP",
  隔夜利息: "Juro overnight",
  设置资产密码: "Definir palavra-passe dos ativos",

  锁仓挖矿: "Mineração com bloqueio",
  一站式理财服务: "Serviço financeiro completo",
  产品: "Produtos",
  客服中心: "Central de atendimento",
  贷款: "Empréstimos",
  挖矿赚不停: "Ganhos contínuos com mineração",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "A mineração com bloqueio consiste em depositar USDT (USD:1USDT=1USD) nas máquinas de mineração de alta performance da plataforma para gerar rendimentos no pool de mineração.",
  产品优势: "Vantagens do produto",
  随存随取: "Depósito e retirada a qualquer momento",
  锁仓周期: "Período de bloqueio",
  每日下发: "Distribuição diária",
  随机空投: "Airdrop aleatório",
  "100%资金安全保障": "100% de segurança dos fundos",
  "100%节假日收益不间断": "Rendimento contínuo mesmo em feriados",
  成功锁仓后当天产出: "Rendimento começa no mesmo dia após o bloqueio",
  关于违约金: "Sobre multa por quebra de contrato",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Se desejar retirar o capital antes do vencimento, será cobrada uma multa. Multa = taxa de penalidade × dias restantes × valor bloqueado.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Exemplo: a taxa de penalidade é de 5%, restam 3 dias para o vencimento e o valor bloqueado é 10000U (USDT/USD). Multa = 5%×3×10000=1500U, e o valor efetivamente devolvido é 15000U-1500U.",
  收益计算: "Cálculo de rendimento",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "A plataforma oferece vários produtos financeiros de mineração com bloqueio. O cálculo do rendimento é o seguinte, por exemplo:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Se o usuário bloquear 10000U (USDT, USD) e escolher um produto de 7 dias com rendimento diário de 0,7%~1,8% do valor bloqueado, o rendimento diário será:",
  "最低:10000Ux0.7%=70U;": "Mínimo: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Máximo: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Após 7 dias, é possível obter um rendimento de 490U~1260U. Os rendimentos são distribuídos diariamente e o capital é transferido automaticamente para a conta ao vencimento.",
  正在托管的资金: "Fundos sob gestão",
  签到: "Check-in",
  锁仓订单: "Ordens bloqueadas",
  预计今日收益: "Rendimento estimado hoje",
  累计收益: "Rendimento acumulado",
  托管中的订单: "Ordens em gestão",
  单笔最少: "Valor mínimo por ordem",
  单笔最多: "Valor máximo por ordem",
  日收益率: "Taxa de rendimento diária",
  说明: "Descrição",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Os dados são baseados no fuso horário GMT+8<br>2. O rendimento diário é calculado com base em todas as ordens liquidadas entre 00:00-23:59 GMT+8<br>3. Os rendimentos são distribuídos no dia seguinte entre 00:00-00:10 GMT+8.",
  知道了: "Entendi",
  锁仓: "Bloquear",
  派息时间: "Horário de pagamento",
  每日: "Diariamente",
  托管资金: "Fundos em custódia",
  到期返回: "Devolução no vencimento",
  提前赎回: "Resgate antecipado",
  预计收益: "Rendimento estimado",
  认购: "Assinatura",
  热门: "Popular",
  数字货币: "Criptomoedas",
  贵金属: "Metais preciosos",
  大宗商品: "Commodities",
  持仓明细: "Detalhes da posição",
  历史明细: "Histórico",
  当前价: "Preço atual",
  "↑买涨": "↑ Comprar alta",
  "↓买跌": "↓ Comprar queda",
  显示全部: "Mostrar tudo",
  买入金额: "Valor de compra",
  方向: "Direção",
  收益: "Lucro",
  预期收益: "Lucro esperado",
  估用保证金: "Margem estimada",
  确认下单: "Confirmar ordem",
  锁定: "Bloqueado",
  账户总资产: "Ativos totais da conta",
  明细: "Detalhes",
  今日收益: "Lucro de hoje",
  仓位保证金: "Margem da posição",
  持有仓位: "Posições abertas",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Valor bloqueado = soma de todas as ordens de mineração bloqueadas não concluídas",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Os dados são baseados no GMT+8<br>2. O rendimento diário é calculado com base em ordens liquidadas",
  充值方式: "Método de depósito",
  银行汇款: "Transferência bancária",
  "银行汇款请联系客服进行操作!":
    "Entre em contato com o suporte para transferência bancária!",
  提款方式: "Método de saque",
  "银行提款请联系客服进行操作!":
    "Entre em contato com o suporte para saque bancário!",
  资金明细: "Detalhes dos fundos",
  提现记录: "Histórico de saques",
  拒绝: "Recusado",
  通过: "Aprovado",
  拒绝原因: "Motivo da recusa",

  消息公告: "Anúncios",
  订单: "Pedidos",
  个人中心: "Centro pessoal",
  "未到期赎回需支付一定的违约金!":
    "O resgate antecipado exige o pagamento de uma penalidade.",
  请输入区号: "Por favor, insira o código de área",
  "请选择国家/地区": "Por favor, selecione um país/região",

  今日开盘: "Abertura de hoje",
  昨日收盘: "Fecho de ontem",

  实名认证即送: "Receba imediatamente após a verificação de identidade",
  立即认证: "Verificar agora",
  新用户礼包: "Pacote de presente para novos usuários",
  完成新人任务领取: "Conclua as tarefas de novo usuário para receber",
  认证: "Verificar",
  时间周期: "Período de tempo",
  支付金额: "Valor do pagamento",
  已平仓: "Fechado",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Pacote de boas-vindas MGBX para novos usuários: cada usuário pode receber no máximo",
  我已经阅读并同意: "Li e concordo com",
  隐私政策: "Política de Privacidade",

  放弃奖励离开: "Desistir da recompensa e sair",
  继续注册: "Continuar o registo",
  分钟: "Minutos",

  "请先勾选隐私政策!":
    "Por favor, consulte a Política de Privacidade primeiro!",

  添加其他到自选: "Adicionar outros à Lista de Acompanhamento",

  充值最高可得: "Faça uma recarga e receba até 30.000 dólares.",

  请输入格式正确的手机号: "Por favor, insira um número de celular válido.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 葡萄牙



// WEBPACK FOOTER //
// ./src/lang/pt.js